import type { ReactNode } from "react";

interface IDiscussionsContainerProps {
  children: ReactNode;
}

export default function DiscussionsContainer({ children }: IDiscussionsContainerProps) {
  return (
    <div className="rounded-xl border border-transparent bg-white shadow-md dark:border-gray-700 dark:bg-gray-800">
      {children}
    </div>
  );
}
